import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useForm } from '@ratehub/base-ui';
import { SCENARIO_TYPES } from '@ratehub/mtg-common';


export default function getMortgageScenarioChooserOptionsPayment(scenarioType, scenarioCount) {
    const form = useForm();

    const purchaseOptions = [
        {
            label: (
                <FormattedMessage
                    id="mtg-calculators.ScenarioChooser.scenario1Label"
                    defaultMessage="Scenario 1 ({value, number, percent1} down)"
                    values={{ value: form.values?.scenarios[0].downPayment?.percent / 100 }}
                />
            ),
            value: 1,
        },
        {
            label: (
                <FormattedMessage
                    id="mtg-calculators.ScenarioChooser.scenario2Label"
                    defaultMessage="Scenario 2 ({value, number, percent1} down)"
                    values={{ value: form.values?.scenarios[1].downPayment?.percent / 100 }}
                />
            ),
            value: 2,
        },
        {
            label: (
                <FormattedMessage
                    id="mtg-calculators.ScenarioChooser.scenario3Label"
                    defaultMessage="Scenario 3 ({value, number, percent1} down)"
                    values={{ value: form.values?.scenarios[2].downPayment?.percent / 100 }}
                />
            ),
            value: 3,
        },
        {
            label: (
                <FormattedMessage
                    id="mtg-calculators.ScenarioChooser.scenario4Label"
                    defaultMessage="Scenario 4 ({value, number, percent1} down)"
                    values={{ value: form.values?.scenarios[3].downPayment?.percent / 100 }}
                />
            ),
            value: 4,
        },
    ];

    const renewalOptions = [
        {
            label: (
                <FormattedMessage
                    id="mtg-calculators.ScenarioChooser.renewalScenario1Label"
                    defaultMessage="Scenario 1"
                />
            ),
            value: 1,
        },
        {
            label: (
                <FormattedMessage
                    id="mtg-calculators.ScenarioChooser.renewalScenario2Label"
                    defaultMessage="Scenario 2"
                />
            ),
            value: 2,
        },
        {
            label: (
                <FormattedMessage
                    id="mtg-calculators.ScenarioChooser.renewalScenario3Label"
                    defaultMessage="Scenario 3"
                />
            ),
            value: 3,
        },
        {
            label: (
                <FormattedMessage
                    id="mtg-calculators.ScenarioChooser.renewalScenario4Label"
                    defaultMessage="Scenario 4"
                />
            ),
            value: 4,
        },
    ];

    const options = scenarioType === SCENARIO_TYPES.PURCHASE ? purchaseOptions : renewalOptions;

    return options.splice(0, scenarioCount);
}
